var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlastic = function SvgPlastic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0143 42.3757C38.0143 44.7195 36.1164 46.6199 33.7727 46.6199C32.6008 46.6199 31.5404 46.1429 30.7729 45.3754",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2559 38.1343C44.5996 38.1343 46.5 36.2364 46.5 33.8927C46.5 32.7208 46.023 31.6604 45.2556 30.893",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0144 41.1338C35.7844 41.9013 36.8449 42.3756 38.0141 42.3756C40.3579 42.3756 42.2556 40.4778 42.2556 38.1341C42.2556 36.9648 41.7812 35.9044 41.0138 35.1344",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.4706,
    cy: 14.5982,
    r: 11.0292,
    fill: "#F4F3F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75903 12.1273L7.5765 13.9447C9.61174 15.9799 5.92495 20.5275 10.9936 25.5961L30.7729 45.3754M12.0073 5.87908L13.8248 7.69645C15.86 9.73169 20.4075 6.0449 25.4761 11.1135L35.3514 20.989L45.2554 30.8928",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04088 12.8455L12.7255 5.16084L9.88395 2.32191C8.94801 1.38597 7.41317 1.38597 6.47722 2.32191L2.20196 6.59727C1.26601 7.53312 1.26601 9.06797 2.20196 10.004L5.04088 12.8455Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8042 26.8199L26.8036 20.8204",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9155 29.9312L29.915 23.9318",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2051 27.8077L16.9048 24.1081C17.0188 22.2102 17.8407 20.4964 19.1085 19.2287C20.3763 17.9609 22.0901 17.1389 23.988 17.0249L27.6876 13.3252",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3606 37.9657L27.0628 34.2634C28.9581 34.1493 30.6718 33.3274 31.9422 32.0622C33.2074 30.7918 34.0293 29.0781 34.1434 27.1828L37.8457 23.4806",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPlastic;